import { render } from "./ClientDeliveryAddresses.vue?vue&type=template&id=1e4daf01&scoped=true"
import script from "./ClientDeliveryAddresses.vue?vue&type=script&lang=js"
export * from "./ClientDeliveryAddresses.vue?vue&type=script&lang=js"

import "./ClientDeliveryAddresses.vue?vue&type=style&index=0&id=1e4daf01&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1e4daf01"]])

export default __exports__